import { render, staticRenderFns } from "./AddSmsSchool.vue?vue&type=template&id=4df506d4&scoped=true"
import script from "./AddSmsSchool.vue?vue&type=script&lang=js"
export * from "./AddSmsSchool.vue?vue&type=script&lang=js"
import style0 from "./AddSmsSchool.vue?vue&type=style&index=0&id=4df506d4&lang=css"
import style1 from "./AddSmsSchool.vue?vue&type=style&index=1&id=4df506d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df506d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df506d4')) {
      api.createRecord('4df506d4', component.options)
    } else {
      api.reload('4df506d4', component.options)
    }
    module.hot.accept("./AddSmsSchool.vue?vue&type=template&id=4df506d4&scoped=true", function () {
      api.rerender('4df506d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/AddSmsSchool.vue"
export default component.exports